// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const UserTasksBoardViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-usertasksboardview" */ "./UserTasksBoardView")).then((page)=>{
        return {
            default: page.UserTasksBoardView
        };
    });
export const LazyUserTasksBoardView = /*#__PURE__*/ lazy(UserTasksBoardViewLazyLoader);
